import React from "react";
import { AppBar, Divider, IconButton, Toolbar } from "@mui/material";
import { Email, LinkedIn } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { Logo } from "src/shared/ui";
import { LocaleSwitcher } from "src/features";

import { Navbar } from "./Navbar/Navbar";

export const Header: React.FC = () => {
  return (
    <AppBar
      component="nav"
      position="sticky"
      sx={{
        backgroundColor: `background.paper`,
      }}
    >
      <Toolbar disableGutters>
        <Logo />
        <Navbar />
        <Divider
          orientation="vertical"
          sx={{
            display: { md: "flex", xs: "none" },
            height: 36,
            borderColor: "text.primary",
          }}
        />

        <IconButton
          size="small"
          color="primary"
          sx={{
            marginLeft: "10px",
            order: { md: "initial", xs: 2 },
          }}
        >
          <Link
            to="https://www.linkedin.com/in/sven-badalyan/"
            target="_blank"
            style={{
              height: "24px",
            }}
          >
            <LinkedIn />
          </Link>
        </IconButton>

        <IconButton
          size="small"
          color="primary"
          sx={{
            order: { md: "initial", xs: 3 },
          }}
        >
          <Link
            to="mailto:contact@svenbadalyan.com"
            target="_blank"
            style={{
              height: "24px",
            }}
          >
            <Email />
          </Link>
        </IconButton>

        <LocaleSwitcher />
      </Toolbar>
    </AppBar>
  );
};
